import React from 'react'

export const LocationContext = React.createContext()
